module.exports = __webpack_public_path__ + "img/30m6.df2acc27.jpg";